Returns active call-related scripts that can be attached to calls created through the public API.

<ApiCodeExamples exampleId="scriptsList" />

<ApiResponseExamples exampleId="scriptsList" />

## Required scope

- `scripts.read`

## Endpoints

- `GET /public/v1/scripts/`: paginated list.
- `GET /public/v1/scripts/{id}/`: detail for one script.

The detail response uses the same field shape as the list item.

## Query parameters

- `page` (`integer`, optional): page number.
- `page_size` (`integer`, optional): items per page. Default `25`, maximum `100`.
- `search` (`string`, optional): searches by script name and description.
- `ordering` (`string`, optional): `name`, `event_type`, `script_type`, `updated_at`, or the same fields prefixed with `-`.
- `event_type` (`string`, optional): filters by event type.
- `script_type` (`string`, optional): filters by script type.

## Response fields

- `id` (`uuid`): script public id. Send `pre_call` scripts in `pre_call_script_id`; send other call scripts in `script_ids`.
- `name` (`string`): script name.
- `description` (`string`): administrative description.
- `event_type` (`string`): call-related trigger event.
- `script_type` (`string`): script implementation type.
- `updated_at` (`datetime`): last update time.

## Option reference

- `event_type`: `pre_call`, `call_started`, `call_completed`, `call_failed`, `call_converted`, `call_optout`.
- `script_type`: `code`, `contact_z_message`.

The catalog exposes an active `pre_call` script only when it has a configured pre-call policy. Do not repeat a `pre_call` script in `script_ids`.

The API does not expose script code, internal assets, execution history, or full internal configuration.

## Expected errors

- `401 Unauthorized`: invalid, expired, revoked, missing, or IP-blocked token.
- `403 Forbidden`: the credential does not have `scripts.read`.
- `404 Not Found`: detail id is not available to the organization.
- `429 Too Many Requests`: credential rate limit exceeded.
